import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import UsersList from '../components/UsersList';

const Users = () => {
  return (
    <div>
      <NavbarTop />
      <UsersList />
      <NavbarBottom />
    </div>
  );
};

export default Users;
